<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog" role="document">
        <form @submit.prevent="importDoors" class="form">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ $t('access.doors.import') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                    <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                        <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                    </span>
                </div>
            </div>

            <div class="modal-body">
                <Button v-if="true" btn-class="btn-md mb-5 w-100" type="new" iconClass="fas fa-download me-2" btn-text="access.doors.download_model" @click="downloadExcel" :is-loading="isLoadingDownload"></Button>
                <InputFileIcon
                    v-if="true"
                    containerClass="col-12"
                    :name="`events-import`"
                    :label="$t('access.doors.enter_import_doors_file')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-sm form-control-solid'"
                    :isRequired="true"
                    size="lg"
                    :placeholder="$t('access.doors.enter_import_doors_file')"
                    v-model="formImportDoors.file"
                />
            </div>
            <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingImport"></Button>
            </div>
            </div>
        </form>
        </div>
    </div>
</template>

<script setup>
    import {ref, defineProps} from 'vue'
    import {useStore} from "vuex";
    import Button from "@/components/Button.vue"
    import InputFileIcon from "@/components/InputFileIcon.vue"

    const store = useStore()

    const props = defineProps({
        id: {
            type: String,
            required: true
        },
    })

    const emits = defineEmits(['load'])

    const isLoadingImport = ref(false)
    const isLoadingDownload = ref(false)
    const formImportDoors = ref({
        file: null
    })

    function closeModal(){
        $('#'+props.id).modal('toggle')
    }

    function importDoors() {
        isLoadingImport.value = true;
        store
            .dispatch('doors/importDoors', formImportDoors.value)
            .then(() => {
                isLoadingImport.value = false;
                emits('load')
                closeModal()
                window.toastr["success"](i18n.global.t('notification.doors_imported'));
            })
            .catch((e) => {
                console.log("errr", e)
                isLoadingImport.value = false;
            });
    }

    const downloadExcel = async () => {   
        try {
            isLoadingDownload.value = true
            const downloadLink = document.createElement('a');
            downloadLink.href = '/assets/media/excel/Fichier_modele_port.xlsx';
            downloadLink.download = 'Fichier_modele_port.xlsx';
            downloadLink.click();
        } catch (e) { }
        isLoadingDownload.value = false
    } 
</script>